var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-wraper"},[_c('navigation',{nativeOn:{"click":function($event){_vm.showMarketHeader && (_vm.$refs.marketChild.searchOpened = false)}}}),(_vm.showMarketHeader)?_c('market',{ref:"marketChild"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }